import { Converter } from '../types/converter';

export const forceConverter: Converter = {
  id: 'force',
  name: 'Force Converter',
  icon: 'ArrowRight',
  categories: ['engineering', 'physics'],
  units: [
    // SI base unit and decimal multiples
    { name: 'Newton', symbol: 'N', factor: 1 },
    { name: 'Exanewton', symbol: 'EN', factor: 1e18 },
    { name: 'Petanewton', symbol: 'PN', factor: 1e15 },
    { name: 'Teranewton', symbol: 'TN', factor: 1e12 },
    { name: 'Giganewton', symbol: 'GN', factor: 1e9 },
    { name: 'Meganewton', symbol: 'MN', factor: 1e6 },
    { name: 'Kilonewton', symbol: 'kN', factor: 1e3 },
    { name: 'Hectonewton', symbol: 'hN', factor: 1e2 },
    { name: 'Dekanewton', symbol: 'daN', factor: 10 },
    { name: 'Decinewton', symbol: 'dN', factor: 0.1 },
    { name: 'Centinewton', symbol: 'cN', factor: 0.01 },
    { name: 'Millinewton', symbol: 'mN', factor: 1e-3 },
    { name: 'Micronewton', symbol: 'µN', factor: 1e-6 },
    { name: 'Nanonewton', symbol: 'nN', factor: 1e-9 },
    { name: 'Piconewton', symbol: 'pN', factor: 1e-12 },
    { name: 'Femtonewton', symbol: 'fN', factor: 1e-15 },
    { name: 'Attonewton', symbol: 'aN', factor: 1e-18 },

    // Gravitational force units
    { name: 'Gram-force', symbol: 'gf', factor: 0.00980665 },
    { name: 'Kilogram-force', symbol: 'kgf', factor: 9.80665 },
    { name: 'Ton-force (metric)', symbol: 'tf', factor: 9806.65 },
    { name: 'Ton-force (short)', symbol: 'tonf (US)', factor: 8896.443230521 },
    { name: 'Ton-force (long)', symbol: 'tonf (UK)', factor: 9964.016427327 },
    
    // Imperial/US force units
    { name: 'Kip', symbol: 'kip', factor: 4448.221615261 },
    { name: 'Pound-force', symbol: 'lbf', factor: 4.448221615261 },
    { name: 'Ounce-force', symbol: 'ozf', factor: 0.2780138509538 },
    { name: 'Poundal', symbol: 'pdl', factor: 0.138254954376 },
    { name: 'Pound foot/square second', symbol: 'lb·ft/s²', factor: 0.138254954376 },

    // CGS and other units
    { name: 'Dyne', symbol: 'dyn', factor: 1e-5 },
    { name: 'Joule/meter', symbol: 'J/m', factor: 1 },
    { name: 'Joule/centimeter', symbol: 'J/cm', factor: 100 },
    { name: 'Pond', symbol: 'p', factor: 0.00980665 },
    { name: 'Kilopond', symbol: 'kp', factor: 9.80665 }
  ]
};
